import { Pipe, PipeTransform } from "@angular/core";
import { REPAIR_STATUS } from "../../../enums/repairStatus.enum";

@Pipe({
  name: "repairStatus",
  standalone: true,
})
export class RepairStatusPipe implements PipeTransform {
  transform(value: unknown): unknown {
    switch (value) {
      case REPAIR_STATUS.None:
        return ".none";

      case REPAIR_STATUS.Created:
        return ".created";

      case REPAIR_STATUS.InProgress:
        return ".in_progress";

      case REPAIR_STATUS.Completed:
        return ".completed";

      case REPAIR_STATUS.Rejected:
        return ".rejected";

      case REPAIR_STATUS.Archived:
        return ".archived";

      default:
        return;
    }
  }
}
